import React from 'react';

// Tabla simple con columnas elegibles. columnas: [{key, label, right?, render(fila), className?}]
export const TablaAtencion = ({ columnas, ver, filas, rowKey, rowTestId, vacio, sticky, maxH }) => {
  const cols = columnas.filter((c) => ver(c.key));
  return (
    <div className={`overflow-auto rounded-lg border border-slate-100 ${maxH || ''}`}>
      <table className="w-full text-sm">
        <thead className={`bg-slate-50 text-left text-slate-500 ${sticky ? 'sticky top-0' : ''}`}>
          <tr>{cols.map((c) => <th key={c.key} className={`whitespace-nowrap px-3 py-2 font-medium ${c.right ? 'text-right' : ''}`}>{c.label}</th>)}</tr>
        </thead>
        <tbody>
          {filas.map((f, i) => (
            <tr key={rowKey(f, i)} className="border-t border-slate-100" data-testid={rowTestId?.(f, i)}>
              {cols.map((c) => (
                <td key={c.key} className={`px-3 py-2 ${c.right ? 'text-right tabular-nums' : ''} ${typeof c.className === 'function' ? c.className(f) : c.className || ''}`}>
                  {c.render ? c.render(f) : f[c.key]}
                </td>
              ))}
            </tr>
          ))}
          {!filas.length && <tr><td colSpan={cols.length} className="px-3 py-6 text-center text-slate-400">{vacio}</td></tr>}
        </tbody>
      </table>
    </div>
  );
};
